import { useEffect, useMemo, useState } from "react";

export const useViewControls = (activeCase) => {
  const [unifiedView, setUnifiedView] = useState(false);
  const [debugMode, setDebugMode] = useState(false);
  const [forceV3, setForceV3] = useState(false);
  const [showConnections, setShowConnections] = useState(false);

  useEffect(() => {
    setUnifiedView(false);
  }, [activeCase]);

  const unifiedOption = useMemo(
    () => ({ value: "unified", display: "Show unified (flattened) filter set" }),
    []
  );

  const connectionsOption = useMemo(
    () => ({ value: "connections", display: "Dataset connections (visual map)" }),
    []
  );

  const forceV3Option = useMemo(
    () => ({ value: "forceV3", display: "Use V3 filter UI (lightbox)" }),
    []
  );

  return {
    unifiedView,
    setUnifiedView,
    unifiedOption,
    debugMode,
    setDebugMode,
    forceV3,
    setForceV3,
    forceV3Option,
    showConnections,
    setShowConnections,
    connectionsOption,
  };
};


